module.exports = {"RI20":"UA-156902540-1","contest-upload-RI20":"UA-156902540-2","contest-instruction-RI20":"UA-156902540-3","trail-RI20":"UA-156902540-4","resource-RI20":"UA-156902540-5","contest-schoolreport-RI20":"UA-156902540-6","contest-faq-RI20":"UA-156902540-7","registration-RI20":"UA-156902540-8","contest-take-RI20":"UA-156902540-9","contest-report-RI20":"UA-156902540-10","defaultId":"UA-156902540-1","TCHR":"UA-156902540-2","STU":"UA-156902540-3"}


//////////////////
// WEBPACK FOOTER
// ./src/config/GA_Tracking_IDS.json
// module id = 613
// module chunks = 0